import script from "./TranslationSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationSelector.vue?vue&type=script&setup=true&lang=js"

import "./TranslationSelector.vue?vue&type=style&index=0&id=6506f910&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6506f910"]])

export default __exports__